import { FormattedMessage } from 'react-intl'

import { Heading } from 'Components/_theme'
import { LanguageDropdown } from 'Components/LanguageDropdown/LanguageDropdown'

export const OfferDeclinedContent = () => (
  <>
    <Heading className="PurchaseContent-heading" size={1}>
      <FormattedMessage id="OfferDeclinedContent_heading" />
    </Heading>

    <div className="PurchaseContent-content">
      <p>
        <FormattedMessage id="OfferDeclinedContent_content_line1" />
      </p>

      <p>
        <FormattedMessage id="OfferDeclinedContent_content_line2" />
      </p>
    </div>

    <LanguageDropdown isLandingPage />
  </>
)
